import "core-js/modules/es.object.to-string";
import _typeof from "/data/devops/workspace/node_modules/@babel/runtime/helpers/esm/typeof";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

var default_1 = function (_super) {
  __extends(default_1, _super);

  function default_1() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.visible = false;
    _this.filedConfigList = [];
    _this.detailData = {};
    return _this;
  }

  default_1.prototype.onVisibleChange = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var _a, _b;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!value) return [3, 3];
            _a = this;
            return [4, this.queryImporterFieldConfig({
              warehouse_code: this.data.warehouse_code || ''
            })];

          case 1:
            _a.filedConfigList = _c.sent();
            _b = this;
            return [4, this.queryImporterDetail({
              id: String(this.data.cv_id)
            })];

          case 2:
            _b.detailData = _c.sent();
            return [3, 4];

          case 3:
            this.filedConfigList = [];
            this.detailData = {};
            _c.label = 4;

          case 4:
            return [2];
        }
      });
    });
  };

  default_1.prototype.getLabelText = function (data) {
    if (data.key_option_list && data.key_option_list.length) {
      var item = this.$util.findItemByKeyValue(data.key_option_list, this.detailData[data.filed].code, 'code');

      if (item) {
        return item.value;
      }
    }

    return data.value;
  };

  default_1.prototype.getValueText = function (data) {
    var res = this.detailData[data.filed];

    if (res === undefined || res === null || res === '') {
      return '';
    }

    var value = _typeof(res) === 'object' ? res.value : res;

    if (data.value_drop_option_list && data.value_drop_option_list.length) {
      var item = this.$util.findItemByKeyValue(data.value_drop_option_list, value, 'key');

      if (item) {
        return item.value;
      }
    }

    return value;
  };

  default_1.prototype.queryImporterDetail = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.queryImportDetail(param)];

          case 1:
            data = _a.sent().data;
            return [2, data];
        }
      });
    });
  };

  default_1.prototype.queryImporterFieldConfig = function (param) {
    return __awaiter(this, void 0, Promise, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.warehouse.queryImporterFieldConfig(param)];

          case 1:
            data = _a.sent().data;
            return [2, data.list];
        }
      });
    });
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return {};
    }
  })], default_1.prototype, "data", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], default_1.prototype, "onVisibleChange", null);

  default_1 = __decorate([Component], default_1);
  return default_1;
}(Vue);

export default default_1;